import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex items-center gap-3 mb-4" }
const _hoisted_2 = { class: "flex gap-1 text-sm" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 1,
  class: "divide-y divide-accent"
}
const _hoisted_5 = { class: "flex-grow min-w-0" }
const _hoisted_6 = { class: "text-xs text-muted mt-1 flex flex-wrap gap-x-3" }
const _hoisted_7 = {
  key: 0,
  class: "text-amber-500"
}
const _hoisted_8 = ["href"]
const _hoisted_9 = ["href"]
const _hoisted_10 = ["href"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 2,
  class: "text-muted text-sm"
}

import type { AmaPlatforms, AmaPost, AmaPublishedLinks } from '#shared/cms/records'

interface AmaEntry {
  rkey: string
  uri: string
  cid: string
  status: 'unanswered' | 'answered'
  question: string
  posts: AmaPost[]
  platforms?: AmaPlatforms
  publishedLinks?: AmaPublishedLinks
  createdAt: string
  answeredAt?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

definePageMeta({ layout: false })
useHead({ title: 'AMA - admin - Daniel Roe' })

const { data, refresh, loading } = useAdminFetch<AmaEntry[]>('/api/admin/ama', { default: () => [] })

const showSkeleton = computed(() => loading.value && !data.value.length)

function hasMissingPublishes (a: AmaEntry): boolean {
  const p = a.platforms
  if (!p) return false
  const links = a.publishedLinks ?? {}
  return (['bluesky', 'mastodon', 'linkedin', 'youtubeShorts'] as const)
    .some(k => p[k] && !links[k])
}

const filter = ref<'todo' | 'all'>('todo')
const visible = computed(() => (data.value ?? []).filter(a => {
  if (filter.value === 'all') return true
  return a.status === 'unanswered' || hasMissingPublishes(a)
}))

const formatter = new Intl.DateTimeFormat('en', { dateStyle: 'medium', timeStyle: 'short' })

async function remove (rkey: string) {
  if (!confirm('Delete this question?')) return
  const previous = data.value
  data.value = data.value.filter(a => a.rkey !== rkey)
  try {
    await $fetch(`/api/admin/ama/${rkey}`, { method: 'DELETE' })
    refresh()
  }
  catch (error) {
    data.value = previous
    throw error
  }
}

return (_ctx: any,_cache: any) => {
  const _component_AdminSkeletonRows = _resolveComponent("AdminSkeletonRows")!
  const _component_NuxtLink = _resolveComponent("NuxtLink")!
  const _component_AdminShell = _resolveComponent("AdminShell")!

  return (_openBlock(), _createBlock(_component_AdminShell, { title: "AMA" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['todo', 'all'] as const, (f) => {
            return _createElementVNode("button", {
              key: f,
              type: "button",
              class: _normalizeClass([_unref(filter) === f ? 'bg-primary text-background' : 'bg-accent text-muted', "px-3 py-1 capitalize hover:opacity-80 transition-opacity"]),
              onClick: ($event: any) => (filter.value = f)
            }, _toDisplayString(f), 11, _hoisted_3)
          }), 64))
        ])
      ]),
      (_unref(showSkeleton))
        ? (_openBlock(), _createBlock(_component_AdminSkeletonRows, {
            key: 0,
            meta: "xs",
            align: "start"
          }))
        : (_openBlock(), _createElementBlock("ul", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(visible), (ama) => {
              return (_openBlock(), _createElementBlock("li", {
                key: ama.rkey,
                class: "py-3 flex items-start gap-4"
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_NuxtLink, {
                    to: `/admin/ama/${ama.rkey}`,
                    class: "block underline-offset-4 hover:underline"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(ama.question), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("span", null, _toDisplayString(ama.status === 'answered' ? '✅' : '✨') + " " + _toDisplayString(ama.status), 1),
                    (hasMissingPublishes(ama))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, "⚠️ needs republish"))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", null, _toDisplayString(_unref(formatter).format(new Date(ama.createdAt))), 1),
                    (ama.publishedLinks?.bluesky)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          href: ama.publishedLinks.bluesky,
                          target: "_blank",
                          rel: "noopener",
                          class: "text-muted hover:text-primary"
                        }, "bluesky ↗", 8, _hoisted_8))
                      : _createCommentVNode("", true),
                    (ama.publishedLinks?.mastodon)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 2,
                          href: ama.publishedLinks.mastodon,
                          target: "_blank",
                          rel: "noopener",
                          class: "text-muted hover:text-primary"
                        }, "mastodon ↗", 8, _hoisted_9))
                      : _createCommentVNode("", true),
                    (ama.publishedLinks?.linkedin)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 3,
                          href: ama.publishedLinks.linkedin,
                          target: "_blank",
                          rel: "noopener",
                          class: "text-muted hover:text-primary"
                        }, "linkedin ↗", 8, _hoisted_10))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "text-sm text-muted hover:text-red-500 transition-colors",
                  onClick: ($event: any) => (remove(ama.rkey))
                }, " Delete ", 8, _hoisted_11)
              ]))
            }), 128))
          ])),
      (!_unref(showSkeleton) && !_unref(visible).length)
        ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_unref(filter) === 'todo' ? 'Nothing to answer or republish.' : 'No questions yet.'), 1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})